// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2KfDG","noInteraction":"EventWrapper_noInteraction__tumYb"};